import { render, staticRenderFns } from "./ClaimExcessCalcList.vue?vue&type=template&id=56d2df62&"
import script from "./ClaimExcessCalcList.vue?vue&type=script&lang=js&"
export * from "./ClaimExcessCalcList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports